import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { impressionsConfig } from './../impressions';

export const mediaViewerImpressionsConfig = {
    ...impressionsConfig,
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.impressions',
    tooltip: null,
    loader: MediaViewerKpiLoader
};
